import React, { forwardRef } from 'react';
import { useSeparator } from '@react-aria/separator';
import { useObjectRef } from '../../hooks/useObjectRef';
import { StyledDivider } from './styled';
export const Divider = forwardRef(function Divider(props, externalRef) {
    const { type = 'horizontal', variant = 'fullWidth', component = 'div', ...rest } = props;
    const ref = useObjectRef(externalRef);
    const { separatorProps } = useSeparator(props);
    return (React.createElement(StyledDivider, { ref: ref, as: component, "$type": type, "$variant": variant, ...rest, ...separatorProps }));
});
